module.exports = "\r\n<div id=\"scrollable-dropdown-menu\">\r\n  <input class=\"typeahead\" type=\"text\" placeholder=\"Countries\">\r\n</div>"